import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Encipher } from '../app-model/key/encipher';
import { ApiProxyService } from '../modules/shared/services/api-proxy.service';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class EncipherService {

  constructor(private apiProxy: ApiProxyService, private configService: ConfigService) { }

  getEnciphers(): Observable<Encipher[]> {
    return this.apiProxy.get(this.configService.apiUrl + 'encipher');
  }

  getEncipher(id: number): Observable<Encipher> {
    return this.apiProxy.get(this.configService.apiUrl + 'encipher/' + id);
  }
}
